export default "__VITE_ASSET__7ISIECBf__"